import { CSSProperties, ReactNode } from "react"
import { motion, useReducedMotion } from "framer-motion"

const FadeFromBottom = ({
  children,
  style,
  delay = 0,
}: {
  children?: ReactNode
  style?: CSSProperties
  delay?: number
}) => {
  const shouldReduceMotion = useReducedMotion()

  return (
    <motion.div
      style={style}
      initial={{ opacity: 0, y: 60 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        delay: shouldReduceMotion ? 0 : delay,
        y: {
          type: "spring",
          duration: 0.4,
        },
      }}
    >
      {children}
    </motion.div>
  )
}

export default FadeFromBottom
